import React from 'react';

/*export const staticRoutes = {//-->MANUAL_APPROACH--/
  Dashboard: React.lazy(() => import('../views/Dashboard')),
};//-*/

const requireContext = require.context(
	'../views',      // Folder path
	false,           // Look in subdirectories?
	/\.(js|jsx)$/    // File extension regex
);

const staticRoutes = {};

requireContext.keys().forEach(file => {
	const componentName = file
		.replace('./', '')
		.replace(/\.(js|jsx)$/, '')
		.split('-')
		.map(part => part.charAt(0).toUpperCase() + part.slice(1))
		.join('');

	// 1. Get the module
	const module = requireContext(file);

	// 2. Verify the component exists
	if (!module?.default) {
		console.error(`Component ${componentName} has no default export in ${file}`);
		return;
	}

	// 3. Create lazy component with proper error handling
	staticRoutes[componentName] = React.lazy(() =>
		Promise.resolve()
			.then(() => ({
				default: module.default
			}))
			.catch(error => ({
				default: () => <div>Failed to load {componentName}: {error.message}</div>
			}))//>
	);
});

export default staticRoutes;